import { SOLD_OUT_STATUS } from './enumSoldOut';

export const AVAILABILITY_STATUS = {
  AVAILABLE: 'available',
  UNAVAILABLE_TODAY: 'unavailable_today',
  UNAVAILABLE_INDEFINITE: 'unavailable_indefinite',
};

export const AVAILABILITY_DOT_COLOR = {
  [AVAILABILITY_STATUS.AVAILABLE]: '#4caf50',
  [AVAILABILITY_STATUS.UNAVAILABLE_TODAY]: '#ff9800',
  [AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITE]: '#f44336',
};

const SOLD_OUT_TO_AVAILABILITY = {
  [SOLD_OUT_STATUS.AVAILABILITY]: AVAILABILITY_STATUS.AVAILABLE,
  [SOLD_OUT_STATUS.SOLD_OUT_TODAY]: AVAILABILITY_STATUS.UNAVAILABLE_TODAY,
  [SOLD_OUT_STATUS.SOLD_OUT_PERMANENT]:
    AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITE,
};

const AVAILABILITY_TO_SOLD_OUT = {
  [AVAILABILITY_STATUS.AVAILABLE]: SOLD_OUT_STATUS.AVAILABILITY,
  [AVAILABILITY_STATUS.UNAVAILABLE_TODAY]: SOLD_OUT_STATUS.SOLD_OUT_TODAY,
  [AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITE]:
    SOLD_OUT_STATUS.SOLD_OUT_PERMANENT,
};

export const toSoldOutStatus = (availabilityStatus) =>
  AVAILABILITY_TO_SOLD_OUT[availabilityStatus] || SOLD_OUT_STATUS.AVAILABILITY;

export const fromSoldOutStatus = (soldOutStatus) =>
  SOLD_OUT_TO_AVAILABILITY[soldOutStatus] || AVAILABILITY_STATUS.AVAILABLE;

export const isUnavailableStatus = (availabilityStatus) =>
  availabilityStatus === AVAILABILITY_STATUS.UNAVAILABLE_TODAY ||
  availabilityStatus === AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITE;

/**
 * End of the current day in the restaurant timezone — not UTC calendar midnight.
 * Matches existing soldOutToday reset behavior.
 */
export const getAvailabilityResetAt = (availabilityStatus, timezone, moment) => {
  if (availabilityStatus === AVAILABILITY_STATUS.AVAILABLE) {
    return null;
  }
  if (availabilityStatus === AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITE) {
    return null;
  }
  const tz = timezone || 'America/Los_Angeles';
  return moment().tz(tz).endOf('day').toISOString();
};

export const toSoldOutPayload = (availabilityStatus, timezone, moment) => ({
  status: toSoldOutStatus(availabilityStatus),
  soldOutDate:
    availabilityStatus === AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITE
      ? '2039-12-31T20:01:00Z'
      : getAvailabilityResetAt(availabilityStatus, timezone, moment),
});
